export const UPDATE_MODEL_VALUE = 'update:modelValue';
